import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import {
  ChevronDown,
  ChevronRight,
  Users,
  Phone,
  Mail,
  Calendar,
} from "lucide-react";
import "./style.scss";

export class MGMDetailsClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: new Set([2, 3]), // Start with root and first level expanded
    };
  }

  // Toggle expand/collapse for a node
  toggleExpand = (id) => {
    const { expanded } = this.state;
    const newExpanded = new Set(expanded);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    this.setState({ expanded: newExpanded });
  };

  // Format date to readable format
  formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // Calculate total points (if points exist, otherwise show descendants count)
  calculateTotalMetric = (node) => {
    if (node.cust_points !== null && node.cust_points !== undefined) {
      // If points system is implemented
      let total = node.cust_points;
      if (node.referrals && node.referrals.length > 0) {
        total += node.referrals.reduce(
          (sum, child) => sum + this.calculateTotalMetric(child),
          0
        );
      }
      return total;
    } else {
      // Fallback to descendants count
      return node.total_descendants || 0;
    }
  };

  // Render individual tree node
  renderTreeNode = (node, level = 0, isLast = false) => {
    const { expanded } = this.state;
    const hasChildren = node.referrals && node.referrals.length > 0;
    const isExpanded = expanded.has(node.id);

    const nodeStyle = {
      marginLeft: `${level * 30}px`,
    };

    const verticalLineStyle = {
      left: `${(level - 1) * 30 + 12}px`,
      top: "-12px",
      height: isLast ? "24px" : "44px",
    };

    const horizontalLineStyle = {
      left: `${(level - 1) * 30 + 12}px`,
      top: "20px",
    };

    return (
      <div key={node.id} className="tree-node" style={nodeStyle}>
        {/* Connection lines */}
        {level > 0 && (
          <div className="tree-node__connection-lines">
            <div
              className="tree-node__vertical-line"
              style={verticalLineStyle}
            />
            <div
              className="tree-node__horizontal-line"
              style={horizontalLineStyle}
            />
          </div>
        )}

        <div className="tree-node__card">
          {/* Expand/Collapse Button */}
          {hasChildren ? (
            <button
              onClick={() => this.toggleExpand(node.id)}
              className="tree-node__expand-btn"
            >
              {isExpanded ? (
                <ChevronDown size={14} className="icon" />
              ) : (
                <ChevronRight size={14} className="icon" />
              )}
            </button>
          ) : (
            <div className="tree-node__dot-indicator">
              <div className="tree-node__dot-indicator-dot" />
            </div>
          )}

          {/* Customer Information */}
          <div className="tree-node__content">
            <div className="tree-node__main-info">
              <div className="tree-node__customer-info">
                {/* Name and Code */}
                <div className="tree-node__name-row">
                  <h4 className="tree-node__name">{node.cust_name}</h4>
                  <span className="tree-node__code">{node.cust_code}</span>
                </div>

                {/* Contact Information */}
                <div className="tree-node__contact-info">
                  {/* {node.cust_email && (
                    <div className="tree-node__contact-item">
                      <Mail size={12} className="icon" />
                      <span>{node.cust_email}</span>
                    </div>
                  )} */}
                  <div className="tree-node__contact-item d-flex align-items-center">
                    <div>
                      <Calendar size={12} className="icon" />
                      <span className="mx-2 mt-1">
                        Joined: {this.formatDate(node.join_date)}
                      </span>
                    </div>

                    {node.cust_phone1 && (
                      <div className="">
                        <Phone size={12} className="icon" />
                        <span className="mx-2 mt-1">{node.cust_phone1}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Metrics */}
              <div className="tree-node__metrics">
                {/* Level Badge */}
                {/* <div className="tree-node__level-badge">Level {node.level}</div> */}

                {/* Points or Metrics */}
                <div className="tree-node__badges">
                  {/* {node.cust_points !== null &&
                  node.cust_points !== undefined ? (
                    <> */}
                  <div className="tree-node__badge tree-node__badge--points-own">
                    Points: {node.cust_points}
                  </div>
                  {/* <div className="tree-node__badge tree-node__badge--points-total">
                    Total: {this.calculateTotalMetric(node)}
                  </div> */}
                  {/* </> */}
                  {/* // ) : (
                  //   <div className="tree-node__badge tree-node__badge--descendants">
                  //     {node.total_descendants} descendants
                  //   </div>
                  // )} */}

                  {/* Direct Referrals */}
                  {/* <div className="tree-node__badge tree-node__badge--direct">
                    <Users size={10} className="icon" />
                    <span>{node.direct_referrals} direct</span>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Child Nodes */}
        {hasChildren && isExpanded && (
          <div className="tree-node__children">
            {node.referrals.map((child, index) =>
              this.renderTreeNode(
                child,
                level + 1,
                index === node.referrals.length - 1
              )
            )}
          </div>
        )}
      </div>
    );
  };

  render() {
    const { data } = this.props;

    if (!data) {
      return (
        <div className="mgm-details">
          <div className="mgm-details__no-data">No customer data available</div>
        </div>
      );
    }

    return (
      <div className="mgm-details">
        {/* Header */}
        <div className="mgm-details__header">
          <h1 className="mgm-details__title">Customer Referral Tree</h1>
          {/* <div className="mgm-details__stats">
            <div className="mgm-details__stats-item">
              <Users size={16} />
              <span>Total Network: {data.total_descendants + 1} customers</span>
            </div>
            <div className="mgm-details__stats-item">
              <Users size={16} />
              <span>Direct Referrals: {data.direct_referrals}</span>
            </div>
          </div> */}
        </div>

        {/* Tree Container */}
        <div className="mgm-details__container">
          {this.renderTreeNode(data)}
        </div>
      </div>
    );
  }
}

export const MGMDetails = withTranslation()(MGMDetailsClass);
